// extracted by mini-css-extract-plugin
export default {"layout":"GlowupPage_layout__l+2li","img":"GlowupPage_img__To3cV"};